var map = {
	"./email.png": 7085,
	"./head.png": 2245,
	"./icon-delete.png": 1708,
	"./icon-delivery.png": 9188,
	"./icon-edit.png": 6925,
	"./icon-order.png": 4623,
	"./phone.png": 9325,
	"./qq.png": 1638,
	"./wx.png": 1386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6003;